import { financeFetcher } from './fetcher';

export const getEntityById = id => {
    return financeFetcher.get(`/finance_entities/${id}`).then(({ response }) => {
        return response;
    });
};

export const updateEntity = (entityId, data) => {
    return financeFetcher.put(`/finance_entities/${entityId}`, {
        data
    });
};

export const getDocumentHeads = financeEntityId => {
    return financeFetcher.get(`/finance_entities/${financeEntityId}/document_heads`).then(({ response }) => response);
};

export const getBankAccounts = financeEntityId => {
    return financeFetcher.get(`/finance_entities/${financeEntityId}/bank_accounts`).then(({ response }) => response);
};

export const getPayoutProfiles = financeEntityId => {
    return financeFetcher.get(`/finance_entities/${financeEntityId}/payout_profiles`).then(({ response }) => response);
};
